import { useEffect } from "react";
import { useError } from "../contexts/ErrorContext";

/**
 * Hook to set up global error listeners
 * Listens to sync errors and other global errors
 * 
 * Requirements: 19.4, 36.2
 */
export function useErrorHandling() {
  const { handleError } = useError();

  useEffect(() => {
    // Listen to sync errors from database service
    const handleSyncError = (event) => {
      const error = event.detail;
      handleError(error, "Sync Error", {
        userMessage: "Sync error occurred. Your changes are saved locally and will sync when connection is restored.",
      });
    };

    // Listen to unhandled promise rejections
    const handleUnhandledRejection = (event) => {
      console.error("[Unhandled Promise Rejection]", event.reason);
      handleError(
        event.reason,
        "Unhandled Promise Rejection",
        {
          silent: true, // Don't show toast for all unhandled rejections
        }
      );
    };

    // Add event listeners
    window.addEventListener("sync-error", handleSyncError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    // Cleanup
    return () => {
      window.removeEventListener("sync-error", handleSyncError);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, [handleError]);
}

export default useErrorHandling;
